/** POST JSON and return the parsed body; throws Error(payload.error) on non-2xx. */
export async function postJson(path: string, body?: object): Promise<unknown> {
  const res = await fetch(path, {
    method: 'POST',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = (await res.json().catch(() => null)) as { error?: string } | null;
  if (!res.ok) throw new Error(payload?.error || `Request failed (${res.status})`);
  return payload;
}
